module.exports = __webpack_public_path__ + "img/icon-hook.6d661dff.svg";